import React from 'react';
import {Phone, Mail, MapPin, Clock} from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#333333] text-white pt-12 pb-6">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="https://static.lumi.new/12/12c5ea1d0a070693e1a629de430b38f5.webp" 
                alt="ONPOINT Mobile Mechanics Logo"
                className="h-12 w-12"
              />
              <div>
                <h3 className="text-xl font-bold">ONPOINT</h3>
                <p className="text-[#4682B4] text-sm">Mobile Mechanics</p>
              </div>
            </div>
            <p className="text-[#E0E0E0] text-sm leading-relaxed">
              Professional mobile auto repair services. We come to you for convenient, reliable car repairs and maintenance.
            </p>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-[#FFD700]">Contact Us</h4>
            <div className="space-y-3">
              <a 
                href="tel:07454922145" 
                className="flex items-center space-x-3 text-[#E0E0E0] hover:text-[#4682B4] transition-colors"
                aria-label="Call ONPOINT Mobile Mechanics"
              >
                <Phone className="w-5 h-5" />
                <span>07454 922145</span>
              </a>
              <a 
                href="mailto:onpointmobilemechanics@gmail.com" 
                className="flex items-center space-x-3 text-[#E0E0E0] hover:text-[#4682B4] transition-colors"
                aria-label="Email ONPOINT Mobile Mechanics"
              >
                <Mail className="w-5 h-5" />
                <span>onpointmobilemechanics@gmail.com</span>
              </a>
              <div className="flex items-start space-x-3 text-[#E0E0E0]">
                <MapPin className="w-5 h-5 mt-1" />
                <span>Mobile Service - We Come To You</span>
              </div>
            </div>
          </div>

          {/* Hours */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-[#FFD700]">Service Hours</h4>
            <div className="space-y-2">
              <div className="flex items-start space-x-3 text-[#E0E0E0]">
                <Clock className="w-5 h-5 mt-1" />
                <div>
                  <p className="font-medium">Monday - Friday</p>
                  <p className="text-sm">8:00 AM - 6:00 PM</p>
                </div>
              </div>
              <div className="flex items-start space-x-3 text-[#E0E0E0] ml-8">
                <div>
                  <p className="font-medium">Saturday</p>
                  <p className="text-sm">9:00 AM - 4:00 PM</p>
                </div>
              </div>
              <div className="flex items-start space-x-3 text-[#E0E0E0] ml-8">
                <div>
                  <p className="font-medium">Sunday</p>
                  <p className="text-sm">Emergency Service Only</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-[#4682B4] pt-6 text-center">
          <p className="text-[#E0E0E0] text-sm">
            © {new Date().getFullYear()} ONPOINT Mobile Mechanics. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
